import { makeStyles } from '@material-ui/core';

export const css = makeStyles(() => ({
  card: {
    width: '920px',
    marginRight: '55px',
    padding: '16px 30px'
  }
}));
